/**
 * Vendor PO Proposal API Service
 * All API calls for Vendor PO Proposal Management (Phase 2)
 * Follows the procurement module API patterns
 */

import api from "../../../services/api";

const BASE_PATH = "/api/v1/procurement";

// ==================== VENDOR PO PROPOSALS ====================

/**
 * Add a vendor PO proposal to a procurement request
 * POST /api/v1/procurement/requests/:requestId/vendor-pos
 * @param {string} requestId - Procurement request ID
 * @param {Object} data - Proposal data { vendorId, poNumber, currency, poDocumentUrl, notes, lineItems, isActive }
 */
export const addVendorPOProposal = async (requestId, data) => {
  const response = await api.post(
    `${BASE_PATH}/requests/${requestId}/vendor-pos`,
    data,
  );
  return response.data;
};

/**
 * Get all vendor PO proposals for a procurement request
 * GET /api/v1/procurement/requests/:requestId/vendor-pos
 * @param {string} requestId - Procurement request ID
 */
export const getVendorPOProposals = async (requestId) => {
  const response = await api.get(
    `${BASE_PATH}/requests/${requestId}/vendor-pos`,
  );
  return response.data;
};

/**
 * Get vendor PO proposal by ID
 * GET /api/v1/procurement/vendor-pos/:id
 * @param {string} id - Proposal ID
 */
export const getVendorPOProposalById = async (id) => {
  const response = await api.get(`${BASE_PATH}/vendor-pos/${id}`);
  return response.data;
};

/**
 * Approve a vendor PO proposal
 * POST /api/v1/procurement/vendor-pos/:id/approve
 * @param {string} id - Proposal ID
 * @param {string} requestId - Procurement request ID (for validation)
 */
export const approveVendorPOProposal = async (id, requestId) => {
  const response = await api.post(`${BASE_PATH}/vendor-pos/${id}/approve`, {
    requestId,
  });
  return response.data;
};

/**
 * Reject a vendor PO proposal
 * POST /api/v1/procurement/vendor-pos/:id/reject
 * @param {string} id - Proposal ID
 * @param {string} rejectionReason - Reason for rejection
 */
export const rejectVendorPOProposal = async (id, rejectionReason) => {
  const response = await api.post(`${BASE_PATH}/vendor-pos/${id}/reject`, {
    rejectionReason,
  });
  return response.data;
};

/**
 * Update vendor PO proposal active status
 * PATCH /api/v1/procurement/vendor-pos/:id/active-status
 * @param {string} id - Proposal ID
 * @param {boolean} isActive - Active state
 */
export const updateVendorPOProposalActiveStatus = async (id, isActive) => {
  const response = await api.patch(
    `${BASE_PATH}/vendor-pos/${id}/active-status`,
    {
      isActive,
    },
  );
  return response.data;
};

// Export all functions as named exports
export default {
  addVendorPOProposal,
  getVendorPOProposals,
  getVendorPOProposalById,
  approveVendorPOProposal,
  rejectVendorPOProposal,
  updateVendorPOProposalActiveStatus,
};
